export * from './color-picker.component';
export * from './color-picker.module';
